import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { F5 } from "@graylog/enterprise-api";
import formValidation from "./utils/formValidation";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { connectionString } = formData;
  const [loading, setLoading] = useState(false);
  const handleSubmit = () => {
    var _a, _b, _c;
    setLoading(true);
    F5.checkCredentials({
      management_ip: ((_a = formData == null ? void 0 : formData.managementIP) == null ? void 0 : _a.value) || "",
      username: ((_b = formData == null ? void 0 : formData.username) == null ? void 0 : _b.value) || "",
      password: ((_c = formData == null ? void 0 : formData.password) == null ? void 0 : _c.value) || ""
    }).then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: t("f5networks.errors.unable_to_connect")
        });
      }
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
      setFormError({
        full_message: err.message,
        nice_message: t("f5networks.errors.unable_to_connect")
      });
    });
  };
  const isFormValid = formValidation.isFormValid(["f5Name", "managementIP", "username", "password"], formData);
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.verify_connection_and_proceed"),
      disabled: isFormValid,
      loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "f5Name",
        type: "text",
        fieldData: formData.f5Name,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        defaultValue: connectionString == null ? void 0 : connectionString.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "managementIP",
        type: "text",
        fieldData: formData.managementIP,
        onChange,
        label: t("f5networks.fields.management_server_host"),
        help: t("f5networks.fields.management_server_host_help"),
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "username",
        type: "text",
        onChange,
        fieldData: formData.username,
        label: t("f5networks.fields.user_name"),
        help: t("f5networks.fields.user_name_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "password",
        type: "password",
        onChange,
        fieldData: formData.password,
        label: t("f5networks.fields.password"),
        help: t("f5networks.fields.password_help"),
        required: true
      }
    )
  );
};
export default StepAuthorize;
